angular.module('SpidApp')

.constant('USER_CONFIG', {
	guichetier: {
		  roleName    : 'GUICHETIER'
		, displayName : 'Guichetier'
		, color       : '#ffc928'
	},
	receveur: {
		  roleName    : 'RECEVEUR'
		, displayName : 'Responsable d\'agence'
		, color       : '#396f9a'
	},
	superviseur: {
		  roleName    : 'SUPERVISEUR'
		, displayName : 'Superviseur'
		, color       : 'grey'
	}
})

.factory('User',
        ['$filter', '$localStorage', 'USER_CONFIG', 
function ($filter,   $localStorage,   USER_CONFIG) {
	/*
		params looks like this:
			{
				id        : 3,
				firstname : '',
				lastname  : '',
				username  : '',
				roles     : 'RECEVEUR,GUICHETIER,SUPERVISEUR'
			}
	*/
	var User = function (params) {
		params = params || {}

		this.id        	       = params.id
		this.username  	       = params.username
		this.firstname 	       = params.firstname
		this.lastname  	       = params.lastname
		this.mail		       = params.mail
		this.roles 		       = params.roles
		this.activeRole        = params.activeRole
		this.agency_ids	       = params.agency_ids
		this.n			       = params.n
		this.tmp_password      = params.tmp_password
		this.is_actif     	   = params.is_actif
		this.state_password    = params.state_password
	}
    
    User.me = function () {
        if ($localStorage.user) {
            return new User($localStorage.user)
        }
        return null
    }

	/*
		In the db, agency_ids looks like : '1,2,3,4' or '1' or ''
	*/
	User.prototype.getAgencyIds = function () {
		return (this.agency_ids || '').split(',')
	}
	
	User.prototype.getFullName = function () {
		var capitalize = $filter('capitalize')
		return capitalize(atob(this.firstname)) + ' ' + capitalize(atob(this.lastname))
	}

	User.GUICHETIER  = USER_CONFIG.guichetier.roleName
	User.RECEVEUR    = USER_CONFIG.receveur.roleName
	User.SUPERVISEUR = USER_CONFIG.superviseur.roleName
	
	User.getDisplayName = function (role) {
		if (!role) {
			throw 'User::getDisplayName() - Missing parameters'
		}
		
		if (role === User.GUICHETIER) {
			return USER_CONFIG.guichetier.displayName
		} else if (role === User.RECEVEUR) {
			return USER_CONFIG.receveur.displayName
		} else if (role === User.SUPERVISEUR) {
			return USER_CONFIG.superviseur.displayName
		}
		
		throw 'User::getDisplayName() - Malformed parameters'
	}

	User.prototype.isRole = function (role) {
		return this.activeRole === role
	}
	
	User.prototype.getMostRole = function () {
		if (this.hasRoleSuperviseur()) {
			return User.SUPERVISEUR
		}
		
		if (this.hasRoleReceveur()) {
			return User.RECEVEUR
		}
		
		if (this.hasRoleGuichetier()) {
			return User.GUICHETIER
		}
		
		return null // I don't understand
	}
	
	User.prototype.isHigherThan = function (user) {
		var mostRole      = this.getMostRole()
		var paramMostRole = user.getMostRole()
		
		if (mostRole === User.SUPERVISEUR && paramMostRole !== User.SUPERVISEUR) {
			return true
		}
		
		if (mostRole === User.RECEVEUR && paramMostRole !== User.SUPERVISEUR && paramMostRole !== User.RECEVEUR) {
			return true
		}
		
		if (mostRole === User.GUICHETIER && paramMostRole !== User.SUPERVISEUR && paramMostRole !== User.RECEVEUR && paramMostRole !== User.GUICHETIER) {
			return true
		}
		
		return false
	}
	
	User.prototype.isGuichetier  = function () { return this.isRole(User.GUICHETIER)  }
	User.prototype.isReceveur    = function () { return this.isRole(User.RECEVEUR)    }
	User.prototype.isSuperviseur = function () { return this.isRole(User.SUPERVISEUR) }

	User.prototype.hasRole = function (role) {
		for (var i = 0 ; i < this.roles.length ; i++) {
			if (this.roles[i] === role) {
				return true
			}
		}
		return false
	}
	
	User.prototype.hasRoleGuichetier  = function () { return this.hasRole(User.GUICHETIER)  }
	User.prototype.hasRoleReceveur    = function () { return this.hasRole(User.RECEVEUR)    }
	User.prototype.hasRoleSuperviseur = function () { return this.hasRole(User.SUPERVISEUR) }

	User.prototype.setDefaultActiveRole = function () {
		// Priority G, R, S
		this.setActiveRole(this.roles[0])
	}

	User.prototype.setActiveRole = function (role) {
		this.activeRole = role
	}
	
	User.prototype.changeRole = function(role) {
		if (!this.hasRole(role)) {
			this.roles.push(role);
		} else {
			this._removeRole(role);
		}
	}
	
	User.prototype._removeRole = function(role) {
		var index = this.roles.lastIndexOf(role);
		if (this.roles.lastIndexOf(role) !== -1) {
			this.roles.splice(index, 1);
		}
	}

	return User
}])